"use strict";
module.exports = {
    entityModel: 'alcoholLicense',
    events: {
        ALCOHOL_LICENSE_UPDATED: 'ALCOHOL_LICENSE_UPDATED',
        ALCOHOL_LICENSE_CREATED: 'ALCOHOL_LICENSE_CREATED',
        ALCOHOL_LICENSE_REVOKED: 'ALCOHOL_LICENSE_REVOKED',
        ALCOHOL_LICENSE_APPROVED: 'ALCOHOL_LICENSE_APPROVED',
    },
    actions: {
        get: 'v1.alcoholLicense.get',
        list: 'v1.alcoholLicense.list',
        writeAlcoholLicenses: 'v1.alcoholLicense.writeAlcoholLicenses',
        upsert: 'v1.alcoholLicense.upsert',
        upsertWhenEmpty: 'v1.alcoholLicense.upsertWhenEmpty',
        updateWhenEmpty: 'v1.alcoholLicense.updateWhenEmpty',
        update: 'v1.alcoholLicense.update',
    },
    categoryCodes: {
        21: '21',
        22: '22',
        41: '41',
        42: '42',
        61: '61',
        62: '62',
        27: '27',
        47: '47',
        67: '67',
        48: '48',
        68: '68',
        91: '91',
        92: '92',
        24: '24',
        25: '25',
        44: '44',
        45: '45',
        64: '64',
        65: '65',
        74: '74',
        75: '75',
        84: '84',
        85: '85',
        94: '94',
        95: '95',
        26: '26',
        46: '46',
        66: '66',
        97: '97',
        98: '98',
        99: '99',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        13: '13',
        14: '14',
        15: '15',
        16: '16',
        17: '17',
        18: '18',
        19: '19',
    },
};
